import { DateDisplay } from '@/components/ui/date-display';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

import type { SnapshotSummary } from '../model/snapshot';

/** Store snapshots by effective date, name and item count. */
export const SnapshotsTable = ({
  snapshots,
}: {
  snapshots: SnapshotSummary[];
}) => (
  <Table noWrapper>
    <TableHeader className="bg-transparent">
      <TableRow>
        <TableHead>Effective at</TableHead>
        <TableHead>Name</TableHead>
        <TableHead className="w-16 text-right">Items</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {snapshots.map((snapshot) => (
        <TableRow key={snapshot.id}>
          <TableCell>
            <DateDisplay
              date={new Date(snapshot.effective_at)}
              displayFormat="iso-short"
              className="font-bold tabular-nums"
            />
          </TableCell>
          <TableCell className="text-muted-foreground">
            {snapshot.name}
          </TableCell>
          <TableCell className="text-right tabular-nums">
            {snapshot.items_count}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
